var _class, _descriptor, _descriptor2, _CatalogSearchProvider;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { autorun, makeObservable, observable, runInAction } from "mobx";
import { Category, SearchAction } from "../../Core/AnalyticEvents/analyticEvents";
import { TerriaErrorSeverity } from "../../Core/TerriaError";
import GroupMixin from "../../ModelMixins/GroupMixin";
import ReferenceMixin from "../../ModelMixins/ReferenceMixin";
import CatalogSearchProviderMixin from "../../ModelMixins/SearchProviders/CatalogSearchProviderMixin";
import CatalogSearchProviderTraits from "../../Traits/SearchProviders/CatalogSearchProviderTraits";
import CommonStrata from "../Definition/CommonStrata";
import CreateModel from "../Definition/CreateModel";
import SearchResult from "./SearchResult";
export function loadAndSearchCatalogRecursively(models, searchTextLowercase, searchResults, resultMap) {
  let iteration = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  // checkTerriaAgainstResults(terria, searchResults)
  // don't go further than 10 deep, but also if we have references that never
  // resolve to a target, might overflow
  if (iteration > 10) {
    return Promise.resolve();
  }
  // add some public interface for terria's `models`?
  const referencesAndGroupsToLoad = models.filter(model => {
    if (resultMap.get(model.uniqueId) === undefined) {
      const modelToSave = model.target || model;
      // Use a flattened string of definition data later,
      // without only checking name/id/descriptions?
      // saveModelToJson(modelToSave, {
      //   includeStrata: [CommonStrata.definition]
      // });
      autorun(reaction => {
        const searchString = "".concat(modelToSave.name, " ").concat(modelToSave.uniqueId, " ").concat(modelToSave.description);
        const matchesString = searchString.toLowerCase().indexOf(searchTextLowercase) !== -1;
        resultMap.set(model.uniqueId, matchesString);
        if (matchesString) {
          runInAction(() => {
            searchResults.results.push(new SearchResult({
              name: modelToSave.name,
              catalogItem: modelToSave
            }));
          });
        }
        reaction.dispose();
      });
    }
    if (ReferenceMixin.isMixedInto(model) || GroupMixin.isMixedInto(model)) {
      return true;
    }
    // Could also check for loadMembers() here, but will be even slower
    // (relies on external non-magda services to be performant)

    return false;
  });

  // If we have no members to load
  if (referencesAndGroupsToLoad.length === 0) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    autorun(reaction => {
      Promise.all(referencesAndGroupsToLoad.map(async model => {
        if (ReferenceMixin.isMixedInto(model)) {
          // TODO: could handle errors better here
          (await model.loadReference()).throwIfError();
        }
        // TODO: investigate performant route for calling loadMembers on additional groupmixins
        // else if (GroupMixin.isMixedInto(model)) {
        //   return model.loadMembers();
        // }
      })).then(() => {
        // Then call this function again to see if new child references were loaded in
        resolve(loadAndSearchCatalogRecursively(models, searchTextLowercase, searchResults, resultMap, iteration + 1));
      }).catch(error => {
        reject(error);
      });
      reaction.dispose();
    });
  });
}
let CatalogSearchProvider = (_class = (_CatalogSearchProvider = class CatalogSearchProvider extends CatalogSearchProviderMixin(CreateModel(CatalogSearchProviderTraits)) {
  constructor(id, terria) {
    super(id, terria);
    _initializerDefineProperty(this, "isSearching", _descriptor, this);
    _initializerDefineProperty(this, "debounceDurationOnceLoaded", _descriptor2, this);
    makeObservable(this);
    this.setTrait(CommonStrata.defaults, "minCharacters", terria.searchBarModel.minCharacters);
  }
  get type() {
    return CatalogSearchProvider.type;
  }
  logEvent(searchText) {
    var _this$terria$analytic;
    (_this$terria$analytic = this.terria.analytics) === null || _this$terria$analytic === void 0 || _this$terria$analytic.logEvent(Category.search, SearchAction.catalog, searchText);
  }
  async doSearch(searchText, searchResults) {
    runInAction(() => this.isSearching = true);
    searchResults.results.length = 0;
    searchResults.message = undefined;
    if (searchText === undefined || /^\s*$/.test(searchText)) {
      runInAction(() => this.isSearching = false);
      return Promise.resolve();
    }

    // Load catalogIndex if needed
    if (this.terria.catalogIndex && !this.terria.catalogIndex.loadPromise) {
      try {
        await this.terria.catalogIndex.load();
      } catch (e) {
        this.terria.raiseErrorToUser(e, "Failed to load catalog index. Searching may be slow/inaccurate");
      }
    }
    const resultMap = new Map();
    try {
      var _this$terria$catalogI;
      if ((_this$terria$catalogI = this.terria.catalogIndex) !== null && _this$terria$catalogI !== void 0 && _this$terria$catalogI.searchIndex) {
        const results = await this.terria.catalogIndex.search(searchText);
        runInAction(() => searchResults.results = results);
      } else {
        await loadAndSearchCatalogRecursively(this.terria.modelValues, searchText.toLowerCase(), searchResults, resultMap);
      }
      runInAction(() => {
        this.isSearching = false;
      });
      if (searchResults.isCanceled) {
        // A new search has superseded this one, so ignore the result.
        return;
      }
      runInAction(() => {
        this.terria.catalogReferencesLoaded = true;
      });
      if (searchResults.results.length === 0) {
        searchResults.message = {
          content: "translate#viewModels.searchNoCatalogueItem"
        };
      }
    } catch (e) {
      this.terria.raiseErrorToUser(e, {
        message: "An error occurred while searching",
        severity: TerriaErrorSeverity.Warning
      });
      if (searchResults.isCanceled) {
        // A new search has superseded this one, so ignore the result.
        return;
      }
      searchResults.message = {
        content: "translate#viewModels.searchErrorOccurred"
      };
    }
  }
}, _defineProperty(_CatalogSearchProvider, "type", "catalog-search-provider"), _CatalogSearchProvider), _descriptor = _applyDecoratedDescriptor(_class.prototype, "isSearching", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "debounceDurationOnceLoaded", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 300;
  }
}), _class);
export { CatalogSearchProvider as default };